export default __webpack_public_path__ + "static/media/collapse.984c53a8.svg";